import { Component, InjectionToken, Type } from '@angular/core';

export const BUILDIG_LAYOUT = new InjectionToken<Type<Component>>('BuildingLayout');
